export default __webpack_public_path__ + "static/media/M_Khurram_Muqueem.32047974.png";